import React from 'react';
import Backdrop from './styles';
import CircularLoading from '../CircularLoading';
var _ref = /*#__PURE__*/React.createElement(CircularLoading, {
  circleColor: "#ffffff",
  width: 60
});
var PageLoader = function PageLoader(props) {
  return /*#__PURE__*/React.createElement(Backdrop, props, _ref);
};
export default PageLoader;